<template>
  <v-dialog
    style="z-index: 101"
    v-model="getModalCadastroContato"
    fullscreen
    persistent
  >
    <v-card outlined :loading="$store.getters.getOverlay">
      <v-card-title>Cadastro de Contato</v-card-title>
      <v-form ref="form" class="px-3">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md2>
              <v-select
                :items="getTiposContatos"
                v-model="tipo"
                label="Tipo"
                dense
                outlined
                class="mr-3 ml-3"
                :rules="rules.tipo"
              ></v-select>
            </v-flex>
            <v-flex xs12 md10>
              <v-text-field
                dense
                outlined
                v-model="getContato.nome"
                label="Nome / Razão Social"
                class="ml-3 mr-3"
                :rules="rules.nome"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                outlined
                v-model="getContato.nome_fantasia"
                label="Nome Fantasia"
                dense
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                dense
                outlined
                v-mask="['##.###.###/####-##', '###.###.###-##']"
                v-model="getContato.cpf_cnpj"
                label="CPF/CNPJ"
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                dense
                outlined
                v-model="getContato.rg_ie"
                label="RG/IE"
                maxlength="15"
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                dense
                outlined
                v-model="getContato.data_nascimento"
                label="Data de Nascimento"
                maxlength="15"
                class="ml-3 mr-3"
                type="date"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-select
                :items="opcoesSexo"
                v-model="getContato.sexo"
                label="Sexo"
                outlined
                dense
                class="ml-3 mr-3"
              ></v-select>
            </v-flex>
            <v-flex xs12 md4>
              <v-select
                :items="opcoesEstadoCivil"
                v-model="getContato.estado_civil"
                label="Estado Civil"
                outlined
                dense
                class="ml-3 mr-3"
              ></v-select>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                dense
                outlined
                v-mask="'#####-###'"
                v-model="getContato.cep"
                label="CEP"
                @blur="pesquisaCep"
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                dense
                outlined
                v-model="getContato.logradouro"
                label="Logradouro"
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                dense
                outlined
                v-model="getContato.numero"
                id="numero"
                label="Número"
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                dense
                outlined
                v-model="getContato.complemento"
                label="Complemento"
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                dense
                outlined
                v-model="getContato.bairro"
                label="Bairro"
                class="ml-3 mr-3"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-autocomplete
                :items="getCidades"
                v-model="cidadeSelecionada"
                label="Cidade"
                class="ml-3 mr-3"
                dense
                outlined
                item-text="nome"
                item-value="nome"
                autocomplete="new-cidade"
                @click="$event.target.select()"
                return-object
                :rules="rules.cidadeSelecionada"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4>
              <v-autocomplete
                :items="getEstados"
                v-model="estadoSelecionado"
                label="Estado"
                class="ml-3 mr-3"
                dense
                outlined
                item-text="uf"
                item-value="uf"
                autocomplete="new-estado"
                @click="$event.target.select()"
                return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                dense
                outlined
                v-mask="'(##) ####-####'"
                v-model="getContato.telefone"
                label="Telefone"
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                dense
                outlined
                v-mask="'(##) #####-####'"
                v-model="getContato.celular1"
                label="Celular 1"
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                dense
                outlined
                v-mask="'(##) #####-####'"
                v-model="getContato.celular2"
                label="Celular 2"
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                dense
                outlined
                v-mask="'(##) #####-####'"
                v-model="getContato.whatsapp"
                label="WhatsApp"
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                dense
                outlined
                v-model="getContato.email"
                label="E-mail"
                class="ml-3 mr-3"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                dense
                outlined
                v-model="getContato.email_notas"
                label="E-mail para envio das notas."
                class="ml-3 mr-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                label="Vendedor"
                outlined
                dense
                class="ml-3 mr-3"
                :value="
                  getContato.funcionario ? getContato.funcionario.nome : ''
                "
                disabled
              ></v-text-field>
            </v-flex>
            <!-- <v-flex xs12 md12>
              <v-textarea
                dense
                outlined
                class="ml-3 mr-3"
                v-model="getContato.observacoes"
                label="Observações"
              ></v-textarea>
            </v-flex> -->
          </v-layout>
        </v-card-text>
        <h2 v-if="getContato.id" align="right" :class="`${getContato.credito > 0 ? 'green--text' : 'back--text'}`">Crédito: R$ {{$helper.formatReal(parseFloat(getContato.credito))}}</h2>
        <v-card-actions>
          <v-btn
            outlined
            color="primary"
            @click="cadastrarContato"
            v-if="
              getContato.id && $helper.verificaPermissao('cadastrar-contato')
            "
            >Novo</v-btn
          >
          <v-btn
            outlined
            color="error"
            @click="setModalExcluirContato(true)"
            v-if="getContato.id && getContato.id != 1 && $helper.verificaPermissao('excluir-contato')"
            >Excluir</v-btn
          >
          <v-btn
            outlined
            color="default"
            @click="
              $store.dispatch('ativaModalConfirmacao', {
                mensagem:
                  'Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?',
                action: 'setModalCadastroContato',
                action_value: false,
              })
            "
            >Voltar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="success"
            @click="salvar"
            :loading="$store.getters.getOverlay"
            v-if="
              getContato.id != 1 &&
              ($helper.verificaPermissao('cadastrar-contato') ||
                $helper.verificaPermissao('atualizar-contato'))
            "
          >
            Salvar</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
    <ModalExcluirContato />
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ModalExcluirContato from "@/pages/contato/ModalExcluir";
export default {
  components: {
    ModalExcluirContato,
  },
  data() {
    return {
      opcoesEstadoCivil: [
        "Solteiro(a)",
        "Casado(a)",
        "Separado(a)",
        "Divorciado(a)",
        "Viúvo(a)",
        "Viúvo(a)",
      ],
      opcoesSexo: ["Masculino", "Feminino"],
      rules: {
        tipo: [(v) => !!v || "Campo obrigatório."],
        nome: [(v) => !!v || "Campo obrigatório."],
        celular1: [(v) => !!v || "Campo obrigatório."],
        cidadeSelecionada: [(v) => !!v || "Campo obrigatório."],
      },
      tipo: "CLIENTE",
      estadoSelecionado: {},
      cidadeSelecionada: {},
    };
  },
  watch: {
    cidadeSelecionada: function () {
      let indexEstado = this.getEstados
        .map((i) => i.uf)
        .indexOf(this.cidadeSelecionada.uf);
      this.estadoSelecionado = this.getEstados[indexEstado];
    },
    getModalCadastroContato: function () {
      if (this.getContato.id) {
        let indexCidade = this.getCidades
          .map((i) => i.codigo)
          .indexOf(this.getContato.codigo_municipio);
        this.cidadeSelecionada = this.getCidades[indexCidade];
      } else {
        this.cidadeSelecionada = {};
      }
    },
  },
  computed: {
    ...mapGetters([
      "getModalCadastroContato",
      "getContato",
      "getTiposContatos",
      "getCidades",
      "getEstados",
    ]),
    getNome() {
      return getContato.nome;
    },
  },
  methods: {
    ...mapActions([
      "setModalCadastroContato",
      "setModalExcluirContato",
      "cadastrarContato",
      "salvarContato",
      "atualizarContato",
      "listarEstados",
      "listarCidades",
    ]),
    salvar() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      this.getContato.tipo = this.tipo;

      if (this.cidadeSelecionada) {
        this.getContato.codigo_municipio = this.cidadeSelecionada.codigo;
        this.getContato.cidade = this.cidadeSelecionada.nome;
      }

      if (this.estadoSelecionado) {
        this.getContato.uf = this.estadoSelecionado.uf;
      }

      if (this.getContato.id) {
        this.atualizarContato(this.getContato);
      } else {
        this.salvarContato(this.getContato);
      }
    },
    pesquisaCep() {
      this.$store.commit("setOverlay", true);
      this.$http
        .get(`https://viacep.com.br/ws/${this.getContato.cep}/json/`)
        .then((res) => {
          this.$store.commit("setOverlay", false);
          this.getContato.logradouro = res.data.logradouro;
          this.getContato.bairro = res.data.bairro;
          this.getContato.cidade = res.data.localidade;
          this.getContato.uf = res.data.uf;
          this.getContato.codigo_municipio = res.data.ibge;
          this.getContato.tipo = this.tipo;
          document.getElementById("numero").focus();
          let indexCidade = this.getCidades
            .map((i) => i.codigo)
            .indexOf(res.data.ibge);
          this.cidadeSelecionada = this.getCidades[indexCidade];
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("setOverlay", false);
        });
    },
  },
  created() {
    if (this.getContato.tipo) {
      this.tipo = this.getContato.tipo;
    }
    this.listarEstados();
    this.listarCidades();
  },
};
</script>
